// "use client";
// import React, { useEffect, useRef, useState } from "react";

// declare global {
//   interface Window {
//     twttr?: {
//       widgets: {
//         load: (element?: HTMLElement) => void;
//         createTweet: (tweetID: string, container: HTMLElement) => void;
//       };
//     };
//   }
// }

// const WIDGET_SCRIPT_URL = "https://platform.twitter.com/widgets.js";

// // ExtractAndRenderTweet Component
// function ExtractAndRenderTweet() {
//   const [tweetID, setTweetID] = useState<string | null>(null);

//   useEffect(() => {
//     const tweetElement = document.querySelector("div[data-lexical-tweet-id]");

//     if (tweetElement) {
//       const extractedTweetID = tweetElement.getAttribute(
//         "data-lexical-tweet-id"
//       );
//       if (extractedTweetID) {
//         setTweetID(extractedTweetID); // Update state with extracted tweet ID

//         // Create the TweetEmbed component and append it after the div
//         const tweetEmbedContainer = document.createElement("div");
//         tweetEmbedContainer.id = "tweet-embed-container";

//         if (!document.getElementById("tweet-embed-container")) {
//           tweetElement.insertAdjacentElement("afterend", tweetEmbedContainer); // Append after the target div
//         }

//         // Render the tweet embed component in the newly created container
//         const renderTweet = () => {
//           if (window?.twttr?.widgets && tweetEmbedContainer) {
//             window.twttr.widgets.createTweet(
//               extractedTweetID,
//               tweetEmbedContainer
//             );
//           }
//         };

//         // Load the Twitter widgets script if it's not already loaded
//         if (!document.getElementById("twitter-widgets-script")) {
//           const script = document.createElement("script");
//           script.id = "twitter-widgets-script";
//           script.src = WIDGET_SCRIPT_URL;
//           script.async = true;
//           script.onload = renderTweet;
//           document.body.appendChild(script);
//         } else {
//           // add loader to the tweet embed container
//           const loader = document.createElement("div");
//           loader.id = "loader";
//           loader.className = "loader"; // Add your loader class here

//           loader.innerHTML = "Loading..."; // Add your loading text or spinner here
//           tweetEmbedContainer.appendChild(loader); // Append loader to the container

//           renderTweet();

//           // hide the original tweet element
//           (tweetElement as HTMLElement).style.display = "none"; // Hide the original tweet element
//         }
//       }
//     }
//   }, [tweetID]);

//   return null; // Nothing is rendered directly in this component
// }

// const Embedded = ({ children }: { children: React.ReactNode }) => {
//   return (
//     <>
//       {children}
//       <ExtractAndRenderTweet />
//     </>
//   );
// };

// export default Embedded;

"use client";
import React, { useEffect } from "react";

declare global {
  interface Window {
    twttr?: {
      widgets: {
        createTweet: (tweetID: string, container: HTMLElement) => Promise<void>;
      };
    };
  }
}

const WIDGET_SCRIPT_URL = "https://platform.twitter.com/widgets.js";

// ExtractAndRenderTweet Component
function ExtractAndRenderTweet() {
  useEffect(() => {
    const tweetElements = document.querySelectorAll(
      "div[data-lexical-tweet-id]"
    );

    if (tweetElements.length === 0) return;

    // Function to render tweets
    const renderTweets = () => {
      tweetElements.forEach((tweetElement, index) => {
        const tweetID = tweetElement.getAttribute("data-lexical-tweet-id");
        if (!tweetID) return;

        // Create container for each tweet
        const containerId = `tweet-embed-container-${index}`;
        let tweetContainer = document.getElementById(
          containerId
        ) as HTMLElement | null;

        if (!tweetContainer) {
          tweetContainer = document.createElement("div");
          tweetContainer.id = containerId;
          tweetContainer.className =
            "tweet-embed-container flex justify-center";
          tweetElement.insertAdjacentElement("afterend", tweetContainer);
        }

        // Add loader
        const loaderId = `loader-${index}`;
        let loader = document.getElementById(loaderId) as HTMLElement | null;
        if (!loader) {
          loader = document.createElement("div");
          loader.id = loaderId;
          loader.className = "loader flex justify-center";
          loader.innerHTML = "Loading tweet...";
          tweetContainer.appendChild(loader);
        }

        // Hide original tweet element
        (tweetElement as HTMLElement).style.display = "none";

        // Render tweet if Twitter widgets are available
        if (window.twttr?.widgets) {
          window.twttr.widgets
            .createTweet(tweetID, tweetContainer)
            .then(() => {
              // Remove loader on successful render
              if (loader) loader.remove();
            })
            .catch(() => {
              if (loader) loader.innerHTML = "Failed to load tweet";
            });
        }
      });
    };

    // Load Twitter script if not already loaded
    if (!document.getElementById("twitter-widgets-script")) {
      const script = document.createElement("script");
      script.id = "twitter-widgets-script";
      script.src = WIDGET_SCRIPT_URL;
      script.async = true;
      script.onload = () => {
        // Ensure twttr is initialized before rendering
        if (window.twttr) {
          renderTweets();
        }
      };
      script.onerror = () => {
        tweetElements.forEach((_, index) => {
          const loader = document.getElementById(`loader-${index}`);
          if (loader) loader.innerHTML = "Failed to load Twitter script";
        });
      };
      document.body.appendChild(script);
    } else {
      // If script is already loaded, render tweets immediately
      renderTweets();
    }

    // Cleanup: Remove containers and show original elements on unmount
    return () => {
      tweetElements.forEach((tweetElement, index) => {
        const container = document.getElementById(
          `tweet-embed-container-${index}`
        );
        if (container) container.remove();
        (tweetElement as HTMLElement).style.display = "";
      });
    };
  }, []); // Run once on mount

  return null;
}

const Embedded = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      {children}
      <ExtractAndRenderTweet />
    </>
  );
};

export default Embedded;
